// Types
import { IsVerifyLastChanceType } from '../types/contract-otp.handlers.utils.type';

const isVerifyLastChance = ({ otpAttempts, verifyAttempts }: IsVerifyLastChanceType): boolean =>
  otpAttempts === 0 && verifyAttempts === 1;

const isNoMoreVerifyAttempts = (verifyAttempts: number | null): boolean => verifyAttempts === 0;

const isRemainingVerifyAttempts = (verifyAttempts: number | null): boolean =>
  verifyAttempts !== null && verifyAttempts >= 1;

export { isNoMoreVerifyAttempts, isRemainingVerifyAttempts, isVerifyLastChance };
